// libs
import cx from 'classnames';
import React, { memo } from 'react';
import { DayPicker } from 'react-day-picker';
// dls
import { TextButton } from '@swiggy-private/dls-web-core/dist/components/TextButton';
// constants
import { DlsColorTokens } from '@/constants/DLSTokens';
// styles
import styles from './Content.module.scss';
import datePickerStyles from 'react-day-picker/dist/style.module.css';
function Content({ value, defaultMonth, setValue, closeMenu, disabledDateMatcher, }) {
    const clearSelection = () => {
        setValue(undefined);
    };
    const classNames = Object.assign(Object.assign({}, datePickerStyles), { root: cx(datePickerStyles.root, styles.dateRoot), button: cx(datePickerStyles.button, styles.dateButton), day_selected: cx(datePickerStyles.day_selected, styles.dateButtonSelected) });
    return (React.createElement("div", { className: styles.container },
        React.createElement(DayPicker, { mode: "single", selected: value, onSelect: setValue, defaultMonth: value !== null && value !== void 0 ? value : defaultMonth, classNames: classNames, disabled: disabledDateMatcher }),
        React.createElement("div", { className: styles.action },
            React.createElement(TextButton, { onClick: clearSelection, buttonSize: "small", color: DlsColorTokens.primary, className: styles.actionButton }, "Clear"),
            React.createElement(TextButton, { onClick: closeMenu, buttonSize: "small", color: DlsColorTokens.primary, className: styles.actionButton }, "Done"))));
}
export default memo(Content);
